import React, { FC } from 'react';
import { TAppendDotsProps } from '../../../types/types';
import CustomCarouselDots from '../../@shared/customCarouselDots';

const AppendDots: FC<TAppendDotsProps> = (props) => {
  const { cardsCount, activeCardIndex, dots } = props;
  if (cardsCount > 0) {
    return (
      <div className="slick-dots">
        <CustomCarouselDots cardsCount={cardsCount} activeCard={activeCardIndex + 1} isDarkMode={false} />
      </div>
    );
  }
  return <ul>{dots}</ul>;
};

export default AppendDots;
